"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEB_EVENTS = void 0;
exports.WEB_EVENTS = {
    APP_VERSION: "INVOKE_APP_VERSION",
    ANALYTICS_CONSENT: "INVOKE_ANALYTICS_CONSENT",
    DOCPACK: "INVOKE_DOCPACK",
    UPDATE_MILEAGE: "INVOKE_UPDATE_MILEAGE",
    REQUEST_TOKEN: "INVOKE_REQUEST_TOKEN",
    SETTLEMENT_FIGURE: "INVOKE_SETTLEMENT_FIGURE",
    FIND_NEW_CAR: "INVOKE_FIND_NEW_CAR",
    ADD_SERVICE_PLAN: "INVOKE_ADD_SERVICE_PLAN",
    BOOK_MOT: "INVOKE_BOOK_MOT",
    PHONE: "INVOKE_PHONE",
    MANAGE_REMINDERS: "INVOKE_MANAGE_REMINDERS",
    BRANCH_LOCATOR: "INVOKE_BRANCH_LOCATOR",
    PRODUCT_ENQUIRE: "INVOKE_PRODUCT_ENQUIRE",
    TERMS_AND_CONDITIONS: "INVOKE_TERMS_AND_CONDITIONS",
    INVOKE_EXTERNAL_URL: "INVOKE_EXTERNAL_URL",
    INVOKE_INTERNAL_URL: "INVOKE_INTERNAL_URL",
    INVOKE_CUSTOM_WEBVIEW: "INVOKE_CUSTOM_WEBVIEW",
    INVOKE_DISMISS_ALL: "INVOKE_DISMISS_ALL",
    INVOKE_DISMISS_THIS: "INVOKE_DISMISS_THIS",
    INVOKE_SET_DISMISS: "INVOKE_SET_DISMISS",
    INVOKE_SERVICING: "INVOKE_SERVICING",
    NATIVE_GEO_LOCATION_SUCCESS: "NATIVE_GEO_LOCATION_SUCCESS",
    NATIVE_GEO_LOCATION_FAILURE: "NATIVE_GEO_LOCATION_FAILURE",
    INVOKE_GET_LOCATION: "INVOKE_GET_LOCATION",
    INVOKE_DASHBOARD_REFRESH: "INVOKE_DASHBOARD_REFRESH",
    INVOKE_NATIVE_SHARE: "INVOKE_NATIVE_SHARE"
};
//# sourceMappingURL=web-events.js.map